import React from "react";

const Faq = () => {
  return <div></div>;
};

export default Faq;
